<template>
  <FiltersDesktop
    v-model:filtersValues="filtersValues"
    class="mb-32 hidden md:block"
    :resetFilters
    :shouldShowFilter
    :submitFilters
  />
  <FiltersMobile
    v-model:filtersValues="filtersValues"
    class="md:hidden"
    :resetFilters
    :shouldShowFilter
    :submitFilters
  />
</template>

<script setup lang="ts">
import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'
import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

import {
  FILTERS_BY_PUBLICATION_STATE,
  FILTER_FIELDS,
} from './Filters.constants'
import type { InitialFilterValues } from './Filters.types'
import FiltersDesktop from './components/FiltersDesktop/FiltersDesktop.vue'
import FiltersMobile from './components/FiltersMobile/FiltersMobile.vue'

const filtersValues = defineModel<InitialFilterValues>('filtersValues', {
  required: true,
})

const props = defineProps<{
  resetFilters: () => void
  submitFilters: () => void
  publicationState: string
}>()

function shouldShowFilter(filter: string) {
  const { activeMarkets } = useSellerInfoStore()
  const hasOnlySingleMarket = activeMarkets.length === 1

  const { isFeatureEnabled } = useBusinessFeaturesStore()
  const isDealsListingsPageEnabled = isFeatureEnabled(
    'isDealsListingsPageEnabled',
  )

  if (
    filter === FILTER_FIELDS.PRICING_STRATEGY &&
    !isDealsListingsPageEnabled
  ) {
    return false
  }

  if (filter === FILTER_FIELDS.MARKET && hasOnlySingleMarket) {
    return false
  }

  return FILTERS_BY_PUBLICATION_STATE[props.publicationState].includes(filter)
}
</script>
